import { render, staticRenderFns } from "./DetalleVigencia.vue?vue&type=template&id=ec6f2a50&"
import script from "./DetalleVigencia.vue?vue&type=script&lang=js&"
export * from "./DetalleVigencia.vue?vue&type=script&lang=js&"
import style0 from "./DetalleVigencia.vue?vue&type=style&index=0&id=ec6f2a50&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports